<template>
    <div id="CreateTsoftChannel">
        <div class="tsoft-container">
            <div class="logo-container">
                <TsoftIcon class="tsoft-logo" />
            </div>
            <div class="alert-box">
                <p>
                    Tsoft panel URL'niz üzerindeki
                    <span class="highlight">https://<span class="highlighted-part">example-tsoft-biz</span>.tsoftpanel.com/</span>
                    kısmını domain kısmına yazmanız gerekiyor.
                </p>
            </div>
            <a-form class="tsoft-form">
                <a-form-item>
                    <a-input
                        size="large"
                        placeholder="Domain adresinizi giriniz"
                        v-model="form.domain"
                        autocomplete="off"
                    >
                        <a-icon slot="prefix" type="global" />
                    </a-input>
                </a-form-item>
                <a-form-item>
                    <a-input
                        size="large"
                        placeholder="Kullanıcı adınızı giriniz"
                        v-model="form.user"
                        autocomplete="off"
                    >
                        <a-icon slot="prefix" type="user" />
                    </a-input>
                </a-form-item>
                <a-form-item>
                    <a-input-password
                        size="large"
                        placeholder="Şifrenizi giriniz"
                        v-model="form.pass"
                        autocomplete="off"
                    >
                        <a-icon slot="prefix" type="lock" />
                    </a-input-password>
                </a-form-item>
                <div class="button-group">
                    <a-button type="default" size="large" @click="handleCancel">
                        Vazgeç
                    </a-button>
                    <a-button type="primary" size="large" @click="handleSubmit" :disabled="loading">
                        <template v-if="loading">
                            <a-spin />
                        </template>
                        <template v-else>
                            Bağlan
                        </template>
                    </a-button>
                </div>
            </a-form>
        </div>
    </div>
</template>

<script>
import TsoftIcon from "../../Chatbot/pages/integrations/svg/TsoftIcon.vue";
import { mapActions, mapState } from "vuex";

export default {
    name: "CreateTsoftChannel",
    components: { TsoftIcon },
    data() {
        return {
            form: {
                domain: "",
                user: "",
                pass: "",
                token: null,
            },
            submitClicked: false,
            loading: false,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site?._id,
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
        }),
        completeCreateChannel(payload) {
            const data = {
                payload,
                type: "t-soft",
                name: "T-SOFT",
            };
            return this.createChannel(data)
                .then(() => {
                    this.$message.success("Channel created successfully");
                    this.$emit("ok");
                })
                .catch((err) => {
                    this.$message.error("Failed to create channel");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSubmit() {
            this.submitClicked = true;
            this.loading = true;
            const payload = {
                domain: this.form.domain.replace(/-/g, "."),
                user: this.form.user,
                pass: this.form.pass,
                token: this.form.token,
            };
            this.completeCreateChannel(payload);
        },
        handleCancel() {
            this.$emit("cancel");
        },
    }
};
</script>

<style lang="scss" scoped>
#CreateTsoftChannel {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;

    .tsoft-container {
        width: 100%;

        .logo-container {
            text-align: center;
            margin-bottom: 2rem;

            .tsoft-logo {
                width: 120px;
                height: auto;
            }
        }

        .alert-box {
            background-color: #fff3cd;
            border: 1px solid #ffeeba;
            padding: 1rem;
            margin-bottom: 1.5rem;
            border-radius: 4px;
            text-align: center;

            .highlight {
                font-weight: bold;
            }

            .highlighted-part {
                background-color: yellow;
            }
        }

        .tsoft-form {
            .ant-form-item {
                margin-bottom: 1.5rem;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .ant-input-affix-wrapper {
                .ant-input {
                    padding-left: 40px;
                }

                .ant-input-prefix {
                    color: #bfbfbf;
                }
            }

            .button-group {
                display: flex;
                justify-content: flex-end;
                gap: 12px;
                margin-top: 2rem;

                .ant-btn {
                    min-width: 120px;
                    height: 40px;
                    font-weight: 500;
                }
            }
        }
    }
}
</style>
